import {
  commonProcessing,
  judgeUserAgent,
  setBgImage,
  getMaterialDataList,
  loadSaveDataWithEvent,
  loadSaveDataWithoutEvent,
  createFoundationBitmap,
  createMaterialAndSetOperations,
  createPreviewMaterial,
  displayChangeMonoColorToolboxOnCreate,
  fixDisplayObject,
  isOverMaterialMaxNum,
  focusChange,
  createFrame,
  getCopyrightType,
} from "../createjsWrapper/src/main";
import {
  initButtons,
  focusOff,
  focusOn,
  closeToolbox,
} from "../createjsWrapper/src/utils/operations";
import * as constants from "../createjsWrapper/src/utils/constants";
import * as colorToolbox from "./utils/colorToolbox";
import * as barrage from "./utils/barrage";
import * as createjs from "createjs-module";

class Edit {
  // preloadQueue;
  // editObjectStage;
  // saveStage;
  // frameStage;

  // displayObjectsContainer;
  // saveContainer;
  // previewContainer;
  // frameContainer;

  static preloadQueue;
  static editObjectStage;
  static saveStage;
  static frameStage;
  static displayObjectsContainer;
  static saveContainer;
  static previewContainer;
  static frameContainer;

  setupEditView() {
    Edit.initEditCanvas();

    // XXX setBgImageでエラーが出ることがあるため、リトライさせる
    try {
      Edit.loadImageCanvasForEdit();
      Edit.setupMaterialPartClickEvent();
      Edit.completeSetupView();
    } catch (e) {
      location.reload();
    }
  }

  /**
   * TODO 機能単位でのファイル分割、共通化推進
   */
  setupWriteView() {
    Edit.initWriteCanvas();

    // XXX setBgImageでエラーが出ることがあるため、リトライさせる
    try {
      Edit.loadImageCanvasForWrite();
      Edit.completeSetupView();
    } catch (e) {
      location.reload();
    }
  }

  static initEditCanvas() {
    const hasSaveStage = true;
    Edit.initCanvas(hasSaveStage);
  }

  static initWriteCanvas() {
    Edit.initCanvas();
  }

  static initCanvas(hasSaveStage = false) {
    Edit.preloadQueue = new createjs.LoadQueue();
    Edit.editObjectStage = new createjs.Stage("edit-object-canvas");
    if (hasSaveStage) {
      Edit.saveStage = new createjs.Stage("save-image-canvas");
    }
    Edit.frameStage = new createjs.Stage("frame-canvas");

    Edit.displayObjectsContainer = new createjs.Container();
    Edit.saveContainer = new createjs.Container(); // TOF 名前は、 Edit.displayObjectsContainer になっているので注意
    Edit.previewContainer = new createjs.Container();
    Edit.frameContainer = new createjs.Container();
  }

  static preload() {
    // パーツ画像サムネイルの遅延読み込み
    //$('img.lazyload').lazyload();
    //
    // fontとframe画像のpreload
    // XXX 現状、preloadが動かないため、fontcssの読み込みをheadで行っている
    // Edit.preloadQueue.loadFile({
    //   id: "font",
    //   src: $("#edit-object-canvas").data("font"),
    //   type: "fontcss", // XXX 元々はcreatejs.TYPES.FONTCSSだったが定義がないためベタ書き
    // });
    // Edit.preloadQueue.loadFile({
    //   id: "frameImage",
    //   src: $("#frame-canvas").data("frame-src"),
    //   type: createjs.LoadQueue.IMAGE, // XXX 元々はcreatejs.TYPES.IMAGEだったが定義がない
    // });
    // Edit.preloadQueue.loadFile({
    //   id: "copyrightImage",
    //   src: $("#frame-canvas").data("copyright-src"),
    //   type: createjs.LoadQueue.IMAGE, // XXX 元々はcreatejs.TYPES.IMAGEだったが定義がない
    // });
    // FIXME ここで詰まってる
    //Edit.preloadQueue.on("complete", Edit.baseImageLoadFunction, this);
    //Edit.preloadQueue.load();
  }

  static addMaterial() {
    if (Edit.previewContainer.numChildren > 0) {
      // 次のためにテキストエリアを消しておく
      $('textarea[name="material-text"]').val("");
      Edit.fixMaterial();
      // 作成素材の選択状態を外す
      $(".material-parts").removeClass("is-select");
    }
  }

  static loadImageCanvasForWrite() {
    Edit.initImageCanvas(false);
    Edit.loadImageCanvas(false, false);
  }

  static loadImageCanvasForEdit() {
    Edit.initImageCanvas(true);
    Edit.loadImageCanvas(true, true);
  }

  /**
   * TODO うまく分離したい
   * @param needEvent
   * @param hasSaveStage
   */
  static loadImageCanvas(needEvent = false, hasSaveStage = false) {
    const baseImageCanvas: JQuery<HTMLCanvasElement> = $("#edit-object-canvas");
    const saveImageCanvas: JQuery<HTMLCanvasElement> = $("#save-image-canvas");

    if (needEvent) {
      // ベース画像のデータ
      Edit.loadCanvasWithEvent(baseImageCanvas, Edit.editObjectStage);
      if (hasSaveStage) {
        // セーブのベース画像のデータ
        Edit.loadCanvasWithEvent(saveImageCanvas, Edit.saveStage);
      }
    } else {
      // ベース画像のデータ
      Edit.loadCanvasWithoutEvent(baseImageCanvas, Edit.editObjectStage);
      if (hasSaveStage) {
        // セーブのベース画像のデータ
        Edit.loadCanvasWithoutEvent(saveImageCanvas, Edit.saveStage);
      }
    }
  }

  static initImageCanvas(hasSaveStage = false) {
    // stageから参照できるように
    Edit.displayObjectsContainer.name = "displayObjectsContainer";
    if (hasSaveStage) {
      Edit.saveContainer.name = "displayObjectsContainer";
    }
    Edit.previewContainer.name = "previewContainer";
    Edit.frameContainer.name = "frameContainer";

    // 背景画像を表示する
    const bgImage = document.querySelector(".canvas-bg");
    setBgImage(Edit.editObjectStage, bgImage);
    if (hasSaveStage) {
      setBgImage(Edit.saveStage, bgImage);
    }

    // ステージとコンテナの関連付け
    Edit.editObjectStage.addChild(Edit.displayObjectsContainer);
    Edit.editObjectStage.addChild(Edit.previewContainer);
    if (hasSaveStage) {
      Edit.saveStage.addChild(Edit.saveContainer);
    }
    Edit.frameStage.addChild(Edit.frameContainer);

    // ボタン類の初期化
    initButtons(Edit.editObjectStage);

    // 共通処理（touchデバイス対応、描画更新など)
    commonProcessing(Edit.editObjectStage);
    judgeUserAgent();
  }

  static completeSetupView() {
    // ボタンの有効化
    $("#form_complete button").prop("disabled", false);
    // 読み込み中表示を消す
    Edit.fadeoutLoading();
  }

  static setupMaterialPartClickEvent() {
    const createPreviewMaterialByData = (decoData) => {
      return createPreviewMaterial(Edit.editObjectStage, decoData);
    };

    // 作成素材配置処理（貼るだけ作成素材）
    $(".material-color-part").on("click", function () {
      const objectImageSrc = $(this).data("target");
      const objectMaterialId = $(this).data("target-id");
      createPreviewMaterialByData({
        type: constants.decoType.normalImage,
        decoId: objectMaterialId,
        src: objectImageSrc,
      });
      $(".material-color-add-btn").removeClass("is-hidden");

      // 一旦すべてを非選択に
      $(".material-color-part").removeClass("is-select");
      $(this).addClass("is-select");
    });

    // 作成素材配置処理（色を変えられる作成素材）
    // $(".material-mono-part").on("click", function () {
    //   const objectCharCode = $(this).data("target");
    //   const objectMaterialId = $(this).data("target-id");
    //   // 文字コードはよくわからないがなぜかJSON.parseするとうまく動いたのでそうしておく
    //   const previewObject = createPreviewMaterialByData({
    //     type: constants.decoType.monoImage,
    //     decoId: objectMaterialId,
    //     text: JSON.parse('"' + objectCharCode + '"'),
    //     color: "#000000",
    //   });
    //   // 色変更toolboxを続けて自動で表示する
    //   //displayChangeMonoColorToolboxOnCreate(previewObject);
    //   //$(".material-mono-add-btn").removeClass("is-hidden");

    //   // 一旦すべてを非選択に
    //   $(".material-mono-part").removeClass("is-select");
    //   $(this).addClass("is-select");
    //   Edit.addMaterial();
    // });

    // 作成素材確定処理
    $(".material-add-btn").on("click", function () {
      Edit.addMaterial();
    });

    // テキストを入力したときにpreviewを更新する
    $('textarea[name="material-text"]').on("keyup", function () {
      updatePreviewOnInputMaterialText();
    });
    const updatePreviewOnInputMaterialText = () => {
      Edit.justifyTextArea();
      Edit.previewText();
      $(".containerWrapper").scrollTop(9999);
    };
  }

  /**
   * TODO うまくフォーカスが効かない問題
   * @param imageSrc
   * @param materialId
   */
  addMaterialColor(imageSrc, materialId) {
    const decoData = {
      type: constants.decoType.normalImage,
      decoId: materialId,
      src: imageSrc,
    };
    createPreviewMaterial(Edit.editObjectStage, decoData);

    $(".material-color-add-btn").removeClass("is-hidden");

    // 一旦すべてを非選択に
    $(".material-color-part").removeClass("is-select");
    //$(this).addClass("is-select");

    Edit.addMaterial();
  }

  addMaterialMono(charCode, materialId) {
    const decoData = {
      type: constants.decoType.monoImage,
      decoId: materialId,
      text: JSON.parse('"' + charCode + '"'),
      color: "#000000",
    };
    createPreviewMaterial(Edit.editObjectStage, decoData);

    // 色変更toolboxを続けて自動で表示する
    //displayChangeMonoColorToolboxOnCreate(previewObject);
    //$(".material-mono-add-btn").removeClass("is-hidden");

    // 一旦すべてを非選択に
    $(".material-mono-part").removeClass("is-select");
    //$(this).addClass("is-select");

    Edit.addMaterial();
  }

  static fadeoutLoading() {
    $("#now-loading").fadeOut(500);
  }

  /**
   * 編集情報を取得
   */
  getEditData() {
    return getMaterialDataList(Edit.editObjectStage);
  }

  showAlertSave() {
    $("#alert-save").removeClass("is-hidden");
    $("#alert-save").addClass("is-visible");
    $(".container").addClass("is-unscrollable");
  }

  closeAlertSave() {
    $("#alert-save").addClass("is-hidden");
    $("#alert-save").removeClass("is-visible");
    $(".container").removeClass("is-unscrollable");
  }

  static loadCanvasWithEvent(canvas: JQuery<HTMLCanvasElement>, stage) {
    Edit.loadCanvas(canvas, stage, true);
  }

  static loadCanvasWithoutEvent(canvas: JQuery<HTMLCanvasElement>, stage) {
    Edit.loadCanvas(canvas, stage, false);
  }

  // オブジェクトのキャンバスへのロード
  // セーブのベース画像のデータや、編集中の画面
  static loadCanvas(
    canvas: JQuery<HTMLCanvasElement>,
    stage,
    needEvent = false
  ) {
    const foundationProperty = {
      src: canvas.data("baseillust-src"),
      x: canvas.data("baseillust-x"),
      y: canvas.data("baseillust-y"),
      scale: canvas.data("baseillust-scale"),
    };
    // ベースイラストがなければロードしない
    if (!foundationProperty.src) {
      return;
    }
    createFoundationBitmap(stage, foundationProperty);

    const editData = canvas.data("edit-data");
    if (needEvent) {
      loadSaveDataWithEvent(stage, editData);
    } else {
      loadSaveDataWithoutEvent(stage, editData);
    }
    stage.update();
  }

  static fixMaterial() {
    fixDisplayObject(Edit.editObjectStage);
    // ダイアログを閉じる
    $(".toolbox").removeClass("is-visible");
    $(".toolbox").addClass("is-hidden");
    // 次のために「追加」ボタンを消しておく
    $(".material-add-btn").addClass("is-hidden");
    // 編集UIの表示
    focusOn();
  }

  completeEdit(writeText = "") {
    window.onbeforeunload = null;

    // 連打防止
    Edit.barrage_prevent_all();

    // ボタン類を消す
    focusOff();

    // 枠の付いたコンテナ
    //const frameContainer = Edit.frameStage.getChildByName("frameContainer");
    const frameChilds = [];

    // コピーライト要素
    if (
      $("#frame-canvas").data("copyright-type") ||
      getCopyrightType(Edit.editObjectStage)
    ) {
      const copyright = new createjs.Bitmap(
        Edit.preloadQueue.getResult("copyrightImage")
      );
      copyright.x = 30;
      copyright.y = 900;
      frameChilds.push(copyright);
    }

    // 編集中の画像を元に座標をずらして生成
    Edit.editObjectStage.cache(0, 0, 750, 750);
    const workCanvas = new createjs.Bitmap(Edit.editObjectStage.cacheCanvas);
    workCanvas.x = 28;
    workCanvas.y = 28;
    frameChilds.push(workCanvas);

    // 投稿用フレームの作成
    createFrame(
      Edit.frameContainer,
      Edit.preloadQueue.getResult("frameImage"),
      frameChilds,
      writeText
    );

    Edit.frameStage.update();
  }

  completeWrite(descriptionText = "") {
    window.onbeforeunload = null;

    // 連打防止
    Edit.barrage_prevent_all();

    // 枠の付いたコンテナ
    const frameContainer = Edit.frameStage.getChildByName("frameContainer");
    const frameChilds = [];

    if (
      $("#frame-canvas").data("copyright-type") ||
      getCopyrightType(Edit.editObjectStage)
    ) {
      const copyright = new createjs.Bitmap(
        Edit.preloadQueue.getResult("copyrightImage")
      );
      copyright.x = 30;
      copyright.y = 900;
      frameChilds.push(copyright);
    }

    // 投稿用フレームの作成
    createFrame(
      Edit.frameContainer,
      Edit.preloadQueue.getResult("frameImage"),
      frameChilds
    );

    Edit.frameStage.update();
  }

  /**
   * 完成画像を取得
   */
  getCompletedImage() {
    return Edit.frameStage.canvas.toDataURL();
  }

  static justifyTextArea() {
    // 直値
    const minTextAreaHeight = 80;
    const lineHeight = 30;
    const textArea = $('textarea[name="material-text"]');
    const inputText = textArea.val() as string;
    const lineCount = Math.max(inputText.split(/\r\n|\n/g).length, 1);
    textArea.css(
      "height",
      minTextAreaHeight + (lineCount - 1) * lineHeight + "px"
    );
  }

  static checkOverText(inputText): boolean {
    const lines = inputText.split(/\r\n|\n/g);
    // 直値
    if (lines.length > 5) {
      return true;
    }
    return lines.some((line) => {
      // 直値
      return line.length > 15;
    });
  }

  static previewText() {
    const inputText = $('textarea[name="material-text"]').val() as string;
    // inputTextがない、もしくは文字数制限を超えている場合は追加ボタンを非表示にする
    if (
      !inputText ||
      inputText.trim().length <= 0 ||
      Edit.checkOverText(inputText)
    ) {
      $(".material-text-add-btn").addClass("is-hidden");
      Edit.previewContainer.removeAllChildren();
      return;
    }
    $(".material-text-add-btn").removeClass("is-hidden");
    const isBorder = $(".border-switch__input").is(":checked");
    const textColor = "#" + $(".material-text-add-btn").data("text-color");
    const textAlign = $(".material-text-add-btn").data("text-align");
    if (isBorder) {
      const outlineColor =
        "#" + $(".material-text-add-btn").data("border-color");
      createPreviewMaterial(Edit.editObjectStage, {
        type: constants.decoType.outlineText,
        text: inputText,
        textAlign: textAlign,
        color: textColor,
        outlineColor: outlineColor,
      });
    } else {
      createPreviewMaterial(Edit.editObjectStage, {
        type: constants.decoType.normalText,
        text: inputText,
        textAlign: textAlign,
        color: textColor,
      });
    }
    return;
  }

  // postするボタンを一括で連打防止
  static barrage_prevent_all() {
    barrage.prevent("#form_complete");
    barrage.prevent("#form_save");
    barrage.prevent("#alert-save");
    barrage.prevent("#form_load");
    barrage.prevent("#alert-load");
  }

  // セーブデータと編集中データに差分があるか
  is_saved(): boolean {
    const save_data = $("#save-image-canvas").data("edit-data");
    // セーブデータがないときはfalse
    if (!save_data || save_data.length == 0) {
      return false;
    }
    const edit_data = getMaterialDataList(Edit.editObjectStage);

    // return edit_data == save_data; XXX 元々これで問題なかったのだが...
    return (
      JSON.stringify(this.objectSort(edit_data)) ==
      JSON.stringify(this.objectSort(save_data))
    );
  }

  /**
   * オブジェクト内の要素を再帰的にソート
   *
   * @param obj
   */
  objectSort(obj) {
    // オブジェクトは順序保証されないので配列化してソートを行う
    const sorted = Object.entries(obj).sort();

    for (const i in sorted) {
      const val = sorted[i][1];
      if (typeof val === "object") {
        sorted[i][1] = this.objectSort(val);
      }
    }
    return sorted;
  }

  onBeforeUnmount() {
    if (this.is_saved()) return;
    const message = "編集中のデータを破棄してよろしいですか？";
    //e.returnValue = message;
    return message;
  }

  showAlertLeave() {
    // セーブ済みでないなら、アラートダイアログ表示
    $("#alert-leave").removeClass("is-hidden");
    $("#alert-leave").addClass("is-visible");
    $(".container").addClass("is-unscrollable");
  }

  closeAlertLeave() {
    $("#alert-leave").addClass("is-hidden");
    $("#alert-leave").removeClass("is-visible");
    $(".container").removeClass("is-unscrollable");
  }

  /****************************
   * 以下、createjsと無関係な処理 ====================================================================================
   ****************************/

  showToolboxSaveOrLoad() {
    const toolbox = document.querySelector(".toolbox--save-load");
    toolbox.classList.remove("is-hidden");
    toolbox.classList.add("is-visible");

    $(".container").addClass("is-unscrollable");

    // XXX 画像の読み込みが終わっていないケースがあるので、セーブのベース画像のデータの再描画
    Edit.saveStage.update();
  }

  showAlertLoad() {
    $("#alert-load").removeClass("is-hidden");
    $("#alert-load").addClass("is-visible");
    $(".container").addClass("is-unscrollable");
  }

  closeAlertLoad() {
    $("#alert-load").addClass("is-hidden");
    $("#alert-load").removeClass("is-visible");
    $(".container").removeClass("is-unscrollable");
  }

  /*************
   * 作成素材アイテム ====================================================================================
   *************/

  setupViewMaterial() {
    // 貼るだけ作成素材・色を変えられる作成素材の切り替え
    $(".tab-menu__deco").on("click", function () {
      const target = $(this).data("target");
      $("." + target).addClass("is-select");
      $("." + target).removeClass("is-unselect");
      const hide_target = $(this).parent().parent();
      hide_target.addClass("is-unselect");
      hide_target.removeClass("is-select");
    });

    // 作成素材アイテムの初期値
    $(".material-parts-container--color").addClass("is-hidden");
    $(".material-parts-container--color").first().removeClass("is-hidden");

    // 作成素材アイテムのタブ切り替え
    $(".item-category").on("click", function () {
      // 一旦すべてを非選択に
      $(".item-category").removeClass("is-select");
      $(this).addClass("is-select");

      // 一旦すべて非表示に
      $(".material-parts-container--color").addClass("is-hidden");
      // 対象のパーツだけ表示
      const categoryId = $(this).data("target");
      $("#material-parts-container--color-" + categoryId).removeClass(
        "is-hidden"
      );
    });
  }

  showToolboxAddItemForItem() {
    // 作成素材最大数が超えていたら表示しない
    if (isOverMaterialMaxNum(Edit.editObjectStage)) {
      return;
    }
    focusOff();
    const toolbox = document.querySelector(".toolbox--add-item");
    toolbox.classList.remove("is-hidden");
    toolbox.classList.add("is-visible");
  }

  /*************
   * テキストアイテム ====================================================================================
   *************/

  setupViewText() {
    // テキストアラインの切り替え
    $(".text-align").on("click", function () {
      $(".text-align").prop("disabled", false);
      $(this).prop("disabled", true);
      const textAlignContainer = $(".text-align-container");
      textAlignContainer.removeClass("is-left");
      textAlignContainer.removeClass("is-center");
      textAlignContainer.removeClass("is-right");
      textAlignContainer.addClass("is-" + $(this).data("target"));
      $(".material-text-add-btn").data("text-align", $(this).data("target"));
      previewTextFunc();
    });

    // 縁の色タブまわり
    $(".border-switch__input").on("change", function () {
      const isBorder = $(".border-switch__input").is(":checked");
      const toolbox = $(this).closest(".toolbox");
      colorToolbox.showBorderTab(isBorder, toolbox, (target) => {
        return toolbox.find(".material-text-add-btn").data(target);
      });
      previewTextFunc();
    });

    const previewTextFunc = Edit.previewText;

    // Androidで、入力時に入力欄が上部に隠れる問題を防ぐため、
    // 入力中はカラーパレットを非表示にする
    let defaultDocumentHeight;
    let afterDisplayVirtualKeyboard;
    $('textarea[name="material-text"]').on("focus", function () {
      if (is_android()) {
        defaultDocumentHeight = $(document).height();
        startAndroidTextInput();
        $(".containerWrapper").scrollTop(9999);
      }
    });
    $('textarea[name="material-text"]').on("blur", function () {
      redisplayTextColor();
    });
    const startAndroidTextInput = () => {
      $(".text-color").css("display", "none");
      // バックボタンでも戻ってくるようにする
      afterDisplayVirtualKeyboard = false;
      setTimeout(checkVirtualKeyboardOff, 200);
    };
    const checkVirtualKeyboardOn = () => {
      if ($(document).height() < defaultDocumentHeight) {
        startAndroidTextInput();
      } else {
        // focusがある限りは判定し続ける
        if ($('textarea[name="material-text"]:focus').length > 0) {
          setTimeout(checkVirtualKeyboardOn, 200);
        }
      }
    };
    const checkVirtualKeyboardOff = () => {
      if ($(document).height() >= defaultDocumentHeight) {
        if (afterDisplayVirtualKeyboard) {
          redisplayTextColor();
          // もう一度バーチャルキーボードが出ることもあるのでイベント登録
          setTimeout(checkVirtualKeyboardOn, 200);
          return;
        }
      } else {
        // バーチャルキーボードが表示されるまでにラグがあるので、その判定をとっておく
        afterDisplayVirtualKeyboard = true;
      }

      setTimeout(checkVirtualKeyboardOff, 200);
    };
    const redisplayTextColor = () => {
      if (is_android()) {
        // チラつき防止のため0.1s遅らせる
        setTimeout(function () {
          $(".text-color").css("display", "block");
        }, 100);
      }
    };

    const is_android = () => {
      return navigator.userAgent.indexOf("Android") > 0;
    };
  }

  /**
   * テキスト追加ダイアログ
   */
  showToolboxAddItemForText() {
    // 作成素材最大数が超えていたら表示しない
    if (isOverMaterialMaxNum(Edit.editObjectStage)) {
      return;
    }
    focusOff();
    const toolbox = document.querySelector(".toolbox--add-text");
    toolbox.classList.remove("is-hidden");
    toolbox.classList.add("is-visible");
    // textareaの初期化
    Edit.justifyTextArea();
  }

  /**********
   * 汎用処理系 ====================================================================================
   **********/

  setupViewCommon() {
    // ダイアログクローズ
    // const closeToolboxFunc = closeToolbox;
    // $(".btn-close").on("click", function () {
    //   const toolbox = $(this).closest(".toolbox");
    //   closeToolboxFunc(toolbox);
    // });

    const removePreview = () => {
      Edit.previewContainer.removeAllChildren();
    };

    // 色の設定
    $(".colorchip").each(function () {
      $(this).css("background-color", "#" + $(this).data("target"));
    });
    $(".colorchip-container").children().first().addClass("is-select");
    $(".colorchip").on("click", function () {
      // 一旦すべてからis-selectを外す
      $(this).parent().children().removeClass("is-select");
      $(this).addClass("is-select");
      // 色をdataとして保存
      const toolbox = $(this).closest(".toolbox");
      if (toolbox.hasClass("toolbox--add-text")) {
        const colorTarget = toolbox
          .find(".tab-menu__text-color.is-select")
          .data("target");
        toolbox
          .find(".material-text-add-btn")
          .data(colorTarget, $(this).data("target"));
        previewTextFunc();
      }
    });

    const previewTextFunc = Edit.previewText;

    // 選択切り替え
    $(".select-change").on("click", function () {
      focusChange();
    });
  }

  closeToolboxByType = (typeName) => {
    const toolbox = $(".toolbox--" + typeName);
    closeToolbox(toolbox);
  };
}

export default Edit;
